export default __webpack_public_path__ + "static/media/screen_google_sheets_02.a521511e.png";